import * as T from "react";
import { i as L, b as M, E as _, x, r as B, c as $ } from "../createReactComponent-58f9bea8.mjs";
import { n as u } from "../property-9daa16cd.mjs";
import { r as g } from "../state-7560d4dc.mjs";
import { e as b } from "../query-d94c86d2.mjs";
import { e as y } from "../class-map-2994e95e.mjs";
import { E as F, R as N } from "../rich-input-suggestion-ae5d08aa.mjs";
import { d as C, c as U, e as z } from "../tooltip-cb602d1f.mjs";
import { a as w, r as D } from "../icon-c572aa57.mjs";
import { r as V } from "../pill-5555e08e.mjs";
import { b as k, r as O } from "../icon-button-87ac6b5d.mjs";
import { g as A } from "../utils-cf5bbdd1.mjs";
import "../base-e16d29d8.mjs";
import "../_commonjsHelpers-10dfc225.mjs";
function S(h) {
  return new DOMParser().parseFromString(h.trim(), "text/html").body.firstChild || document.createElement("div");
}
const E = "exo-mention", v = "exo-filter-highlight", p = "exo-text-block";
class l extends F {
  constructor(e) {
    super({ ...e, defaultBehavior: !1, browserSpellcheck: !1 }), this.templates = e.templates, this.trigger = e.trigger, this.allowShiftEnter = e.allowShiftEnter;
  }
  add(e) {
    return super.add(e), this.element = e, this;
  }
  getValue(e = !0) {
    return this.element && this.element.childNodes.length ? Array.from(this.element.childNodes).filter((t) => {
      var i;
      let n = !0;
      return e && (n = !((i = t.classList) != null && i.contains(v))), !!t && n;
    }).map((t) => {
      var n;
      return (n = t.classList) != null && n.contains(E) ? t.dataset.value ? `[[${t.dataset.value}]]` : "" : t.nodeName === "BR" ? "__NEW_LINE__" : t.textContent;
    }).join("").replace(/[\n]/g, "").replace(/[\s]+/g, " ").replace(/__NEW_LINE__/g, `
`).trim() : "";
  }
  static focus(e, t = 0, n = !1) {
    var s;
    const i = window.getSelection(), o = document.createRange();
    e.nodeType === 3 ? o.setStart(e, t) : o.selectNodeContents(e), o.collapse(n), i == null || i.removeAllRanges(), i == null || i.addRange(o), (s = e == null ? void 0 : e.focus) == null || s.call(e), o.detach();
  }
  static createText(e = "") {
    return S(`<span class="${p}" contentEditable="true">${e}</span>`);
  }
  static createBreak() {
    return document.createElement("br");
  }
  getFocusedBlock() {
    var i, o, s, r;
    const e = window.getSelection();
    let t;
    const n = e == null ? void 0 : e.focusOffset;
    return (e == null ? void 0 : e.focusNode) === this.element ? (t = l.createText(""), this.element.appendChild(t)) : t = ((i = e == null ? void 0 : e.focusNode) == null ? void 0 : i.nodeType) === 3 && ((o = e == null ? void 0 : e.focusNode.parentElement) != null && o.classList.contains(p)) ? e == null ? void 0 : e.focusNode.parentElement : (r = (s = e == null ? void 0 : e.focusNode) == null ? void 0 : s.classList) != null && r.contains(p) ? e == null ? void 0 : e.focusNode : this.element.querySelector(`.${p}`), { focusedElement: t, offset: n || 0 };
  }
  handleBackspace(e) {
    var n, i, o, s;
    const t = (n = this.lastCursor) == null ? void 0 : n.focusedBlock;
    t && e.key === "Backspace" && ((i = t.textContent) == null ? void 0 : i.length) === 1 && ((s = (o = t.previousElementSibling) == null ? void 0 : o.classList) != null && s.contains(E)) && t.previousElementSibling.remove();
  }
  handleDelete(e) {
    var r, d;
    const t = this.getFocusedBlock(), n = t.focusedElement, i = t.offset, o = n == null ? void 0 : n.textContent, s = (o == null ? void 0 : o.length) ?? 0;
    n && e.key === "Delete" && (i === s || i === s - 1) && ((d = (r = n.nextElementSibling) == null ? void 0 : r.classList) != null && d.contains(E)) && n.nextElementSibling.remove();
  }
  handleTriggerKey(e) {
    var t, n;
    if (e.key === this.trigger) {
      e.preventDefault();
      const i = this.element.querySelector(`.${v}`);
      i && i.classList.remove(v);
      const o = this.getFocusedBlock(), s = o.offset, r = o.focusedElement, d = l.createText(((t = r == null ? void 0 : r.textContent) == null ? void 0 : t.substring(0, s)) || ""), m = l.createText(((n = r == null ? void 0 : r.textContent) == null ? void 0 : n.substring(s)) || "");
      r && (this.element.insertBefore(d, r), this.element.insertBefore(m, r));
      const f = l.createText("#");
      f.classList.add(v), f && (this.element.insertBefore(f, m), l.focus(f)), r == null || r.remove();
    }
  }
  handleShiftEnter() {
    var e, t;
    if (this.allowShiftEnter) {
      const n = this.getFocusedBlock(), i = n.offset, o = n.focusedElement, s = l.createText(((e = o == null ? void 0 : o.textContent) == null ? void 0 : e.substring(0, i)) || ""), r = l.createText(((t = o == null ? void 0 : o.textContent) == null ? void 0 : t.substring(i)) || "");
      o && (this.element.insertBefore(s, o), this.element.insertBefore(r, o));
      const d = l.createBreak();
      d && (this.element.insertBefore(d, r), l.focus(r, 0, !0)), o == null || o.remove();
    }
  }
  handleKeydown(e) {
    this.handleBackspace(e), this.handleTriggerKey(e), this.handleDelete(e);
  }
  findFocusedTextBlock(e) {
    var t, n, i;
    if ((e == null ? void 0 : e.nodeType) === 3 && ((n = (t = e == null ? void 0 : e.parentElement) == null ? void 0 : t.classList) != null && n.contains(p)))
      return e.parentElement;
    if ((i = e == null ? void 0 : e.classList) != null && i.contains(p))
      return e;
    if (e === this.element) {
      const o = this.element.querySelector(`span.${p}:first-child`);
      if (o)
        return o;
      const s = l.createText("&nbsp;");
      return this.element.appendChild(s), l.focus(s), s;
    }
    return e;
  }
  setCursor(e) {
    e && (this.lastCursor = { focusedBlock: this.findFocusedTextBlock(e) });
  }
  initializeEvents() {
    super.on("cursor", (e, t) => {
      var n;
      e && t && this.setCursor((n = t.range) == null ? void 0 : n.startContainer);
    }), super.on("newline", () => {
      this.handleShiftEnter();
    }), this.element.addEventListener("keydown", (e) => {
      this.handleKeydown(e);
    }), this.element.addEventListener("paste", (e) => {
      var n, i, o;
      const t = (n = e.clipboardData || e.clipboardData) == null ? void 0 : n.getData("text");
      if (t) {
        e.preventDefault();
        const s = window.getSelection();
        if (s && s.rangeCount) {
          if (s.deleteFromDocument(), s.focusNode === this.element)
            s.getRangeAt(0).insertNode(l.createText(t)), s.collapseToEnd();
          else if (((i = s.focusNode) == null ? void 0 : i.nodeType) === 3 && ((o = s.focusNode.parentElement) != null && o.classList.contains(p))) {
            const r = s.focusNode, d = r.nodeValue || "", m = s.focusOffset;
            r.nodeValue = d.substring(0, m) + t + d.substring(m), l.focus(r, m + t.length);
          }
        }
      }
    }), this.element.addEventListener("beforeinput", (e) => {
      e.inputType === "historyUndo" && e.preventDefault();
    });
  }
  on(e, t) {
    switch (e) {
      case "change":
        super.on("change", () => {
          var o;
          const n = this.lastCursor.focusedBlock, i = { mentionFilter: "", value: this.getValue() };
          (o = n == null ? void 0 : n.classList) != null && o.contains(v) && (i.mentionFilter = n.innerText.replace("#", "")), t(i);
        });
        break;
      case "keyup":
        this.element.addEventListener("keyup", t);
        break;
      default:
        super.on(e, t);
    }
  }
  init() {
    this.initializeEvents(), this.editorMutationObserver && this.editorMutationObserver.disconnect(), this.editorMutationObserver = new MutationObserver(() => {
      this.handleElementMutation();
    }), this.editorMutationObserver.observe(this.element, { childList: !0, subtree: !0 }), this.handleElementMutation();
  }
  setValue(e, t = [], n = !1) {
    if (e && this.element) {
      const i = l.getTokenizedValue(e, t);
      this.element.innerHTML = "", i.map((o) => typeof o == "string" ? l.createText(o) : this.createMention(o)).forEach((o) => this.element.appendChild(o)), n && l.focus(this.element);
    }
  }
  clear(e = !1) {
    this.element && (this.element.innerHTML = "", e && l.focus(this.element));
  }
  handleElementMutation() {
    var t, n;
    this.element.querySelector(`span.${p}`) || this.element.replaceChildren(l.createText("&nbsp;"));
    const e = this.element.querySelector("font");
    if (e && ((t = e.parentElement) != null && t.classList.contains(p))) {
      if (e.previousSibling)
        e.previousSibling.nodeValue = (e.previousSibling.nodeValue || "") + e.innerText;
      else if (e.nextSibling) {
        const i = e.nextSibling;
        i.nodeValue = e.innerText + (i.nodeValue || ""), l.focus(i, ((n = e.textContent) == null ? void 0 : n.length) ?? 0);
      }
      e.remove();
    }
  }
  createMention(e) {
    const t = Math.random().toString(36).substring(2).replace(/\d/g, ""), n = this.templates.mentions(e, t);
    return n.dataset.value = e.value, n.id = t, n.classList.add(E), n;
  }
  addMention(e) {
    const t = this.createMention(e), n = this.element.querySelector(`span.${v}`);
    if (n) {
      this.element.insertBefore(t, n);
      const i = l.createText("&nbsp;");
      this.element.replaceChild(i, n), l.focus(i);
    }
  }
  removeMention(e) {
    var t;
    (t = this.element.querySelector(`#${e}`)) == null || t.remove();
  }
  static getTokenizedValue(e, t = []) {
    return e == null ? void 0 : e.split(/(\[\[[^\]]*\]\])/gi).map((n) => {
      var i;
      return ((i = n.match(/\[\[[^\]]*\]\]/gi)) == null ? void 0 : i.length) && t.find((o) => `[[${o.value}]]` === n) || n;
    });
  }
}
class q {
  constructor(e) {
    this.isFirstUpdate = !0, (this.host = e).addController(this);
  }
  hostUpdated() {
    this.isFirstUpdate && (this.isFirstUpdate = !1, this.hostFirstUpdated());
  }
  hostFirstUpdated() {
    this.initiateFloatingDom(), this.intializeEvents();
  }
  initiateFloatingDom() {
    C(this.host.container, this.host.suggestions, () => {
      U(this.host.container, this.host.suggestions, { strategy: "fixed", middleware: [z({ allowedPlacements: ["top", "bottom"] })] }).then(({ x: e, y: t, placement: n }) => {
        Object.assign(this.host.suggestions.style, { left: `${e}px`, top: `${t}px` }), this.host.suggestionPlacement = n;
      });
    });
  }
  onSuggestionClick(e) {
    const t = e.target.closest("ex-rich-input-suggestion");
    this.applySuggestions(t);
  }
  onSuggestionKeyup(e) {
    var t;
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      const n = document.activeElement;
      if (n.nodeName.toLowerCase() === "ex-rich-input-suggestion")
        if (e.key === "ArrowDown") {
          const i = n == null ? void 0 : n.nextElementSibling;
          i ? i.focus() : l.focus(this.host.editor.element);
        } else {
          const i = n == null ? void 0 : n.previousElementSibling;
          i ? i.focus() : l.focus(this.host.editor.element);
        }
    } else
      e.key === "Enter" && ((t = document.activeElement) == null ? void 0 : t.nodeName.toLowerCase()) === "ex-rich-input-suggestion" && this.applySuggestions(document.activeElement);
  }
  intializeEvents() {
    this.host.suggestions.addEventListener("click", (e) => this.onSuggestionClick(e)), this.host.suggestions.addEventListener("keyup", (e) => this.onSuggestionKeyup(e));
  }
  applySuggestions(e) {
    if (e && e.value) {
      let t;
      this.host.showSuggestions = !1, e.type === N.AUTOCOMPLETE ? (this.host.editor.setValue(e.value, e.context, !0), t = { context: e.context, value: e.value }) : (this.host.editor.addMention({ label: e.label, value: e.value }), t = { lable: e.label, value: e.value }), this.host.dispatchCustomEvent("onSuggestionSelect", t);
    }
  }
}
class R {
  constructor(e) {
    this.isFirstUpdate = !0, (this.host = e).addController(this);
  }
  hostUpdated() {
    this.isFirstUpdate && (this.isFirstUpdate = !1, this.hostFirstUpdated()), this.contentEditable.contentEditable = (!this.host.disabled).toString(), Array.from(this.contentEditable.querySelectorAll("[contenteditable]") || []).forEach((e) => {
      e.contentEditable = (!this.host.disabled).toString();
    }), this.contentEditable.classList.toggle("has-error", this.host.invalid && !this.host.isEmpty);
  }
  initializeEditorTemplate() {
    this.inputContainer = S(`
      <div>
        <div contentEditable></div>
        <style>ex-rich-input div[contenteditable]{display:inline-block;width:100%;border:none;outline:none;line-height:30px;position:relative;text-align:left;color:var(--exo-color-font)}ex-rich-input div[contenteditable].has-mentions{line-height:40px}ex-rich-input div[contenteditable] .exo-filter-highlight{color:var(--exo-color-font-link);display:inline}ex-rich-input div[contenteditable].has-error .exo-text-block:not(.exo-filter-highlight){background:var(--exo-color-background-danger-weak)}
</style>
      </div>
    `), this.host.appendChild(this.inputContainer);
  }
  hostDisconnected() {
    var e, t, n, i;
    (t = (e = this.host.editor) == null ? void 0 : e.remove) == null || t.call(e, this.inputContainer.querySelector("[contenteditable]")), (i = (n = this.host.editor) == null ? void 0 : n.unload) == null || i.call(n);
  }
  initializeEditor() {
    this.host.editor = new l({ trigger: "#", templates: { mentions: (e, t) => {
      const n = S(`
            <ex-pill color="aqua" size="regular" removable interactive selected contenteditable="false" tabindex="-1">
              ${e.label}
            </ex-pill>
          `);
      return n.addEventListener("onRemove", () => {
        this.host.editor.removeMention(t);
      }), n;
    } }, allowShiftEnter: this.host.allowShiftEnter }), this.contentEditable = this.inputContainer.querySelector("[contenteditable]"), this.contentEditable && (this.host.editor.add(this.contentEditable), this.host.editor.init(), this.host.editor.setValue(this.host.value, this.host.context));
  }
  onChange(e) {
    const t = e;
    t.mentionFilter ? this.host.dispatchCustomEvent("onMention", { searchKey: t.mentionFilter }) : this.host.dispatchCustomEvent("onChange", { value: t.value });
  }
  onFocus() {
    this.host.focused = !0, this.host.showSuggestions = !0, this.host.dispatchCustomEvent("onFocus", { value: this.host.editor.getValue() });
  }
  onBlur() {
    this.host.focused = !1, this.host.dispatchCustomEvent("onBlur", { value: this.host.editor.getValue() }), setTimeout(() => {
      var e;
      ((e = document.activeElement) == null ? void 0 : e.nodeName.toLowerCase()) !== "ex-rich-input-suggestion" && (this.host.showSuggestions = !1);
    }, 200);
  }
  onKeyUp(e) {
    var t, n;
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const i = (t = this.host.suggestionsSlot.assignedElements()) == null ? void 0 : t[0], o = i == null ? void 0 : i.querySelector("ex-rich-input-suggestion:last-child");
      o == null || o.focus();
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      const i = (n = this.host.suggestionsSlot.assignedElements()) == null ? void 0 : n[0], o = i == null ? void 0 : i.querySelector("ex-rich-input-suggestion:first-child");
      o == null || o.focus();
    } else
      e.key !== "Enter" || e.shiftKey || this.host.disabled || this.host.invalid || this.host.isEmpty || (this.host.dispatchCustomEvent("onSend", { value: this.host.editor.getValue() }), this.host.clearOnSend && this.host.editor.clear(this.host.focused));
    this.host.showSuggestions = !0, this.updateEditorEmptyState();
  }
  initializeEvents() {
    this.host.editor.on("change", (e) => this.onChange(e)), this.host.editor.on("focus", () => this.onFocus()), this.host.editor.on("blur", () => this.onBlur()), this.host.editor.on("keyup", (e) => this.onKeyUp(e));
  }
  updateEditorEmptyState() {
    const e = !this.host.editor.getValue().trim();
    this.host.isEmpty !== e && (this.host.isEmpty = e, this.host.requestUpdate());
  }
  handleEditorMutation() {
    var e, t, n;
    this.updateEditorEmptyState(), (e = this.contentEditable) != null && e.querySelector("ex-pill") ? (t = this.contentEditable) == null || t.classList.add("has-mentions") : (n = this.contentEditable) == null || n.classList.remove("has-mentions");
  }
  hostFirstUpdated() {
    this.initializeEditorTemplate(), this.initializeEditor(), this.initializeEvents(), this.handleEditorMutation(), this.contentEditable && new MutationObserver(() => {
      this.handleEditorMutation();
    }).observe(this.contentEditable, { childList: !0, subtree: !0 });
  }
}
var I = Object.defineProperty, K = Object.getOwnPropertyDescriptor, c = (h, e, t, n) => {
  for (var i, o = n > 1 ? void 0 : n ? K(e, t) : e, s = h.length - 1; s >= 0; s--)
    (i = h[s]) && (o = (n ? i(e, t, o) : i(o)) || o);
  return n && o && I(e, t, o), o;
}, P = ((h) => (h.DEFAULT = "default", h.BRAND = "brand", h))(P || {});
class a extends _ {
  constructor() {
    super(), this.type = "brand", this.value = "", this.context = [], this.invalid = !1, this.disabled = !1, this.placeholder = "How can I help you?", this.helpText = "", this.errorMsg = "", this.clearOnSend = !1, this.allowShiftEnter = !1, this.isMultiline = !1, this.focused = !1, this.isEmpty = !1, new q(this), new R(this);
  }
  updateIsMultiline() {
    this.isMultiline = this.container.clientHeight > 68;
  }
  firstUpdated() {
    new ResizeObserver(() => this.updateIsMultiline()).observe(this.container);
  }
  getValue() {
    return this.editor.getValue();
  }
  onslotchangeHandler() {
    this.hasSuggestion = this.suggestionsSlot.assignedElements().length > 0;
  }
  isLeftActionSlotUsed() {
    this.hasPrefix = this.leftActionSlot.assignedNodes().length > 0;
  }
  render() {
    var t;
    const e = !((t = this.editor) != null && t.getValue(!1));
    return x`
      <div
        class="${y({ container: !0, "container--variant__branded": this.type === "brand", "container--variant__default": this.type === "default", "container--state__focused": this.focused, "container--state__invalid": this.invalid, "container--state__disabled": this.disabled })}"
      >
        <div
          class="${y({ "inner-container": !0, "inner-container--has-multiline": this.isMultiline })}"
        >
          <div
            class="${y({ "left-icon--container": !0, hidden: !this.hasPrefix })}"
          >
            <slot
              name="left-action"
              @slotchange=${this.isLeftActionSlotUsed}
            ></slot>
          </div>
          <div class="input--container">
            ${!this.focused && e && this.placeholder ? x`<div class="input--placeholder">${this.placeholder}</div>` : ""}
            <slot></slot>
            <div
              class="${y({ suggestions: !0, "suggestions--hidden": !this.showSuggestions || !this.hasSuggestion })}"
            >
              <slot
                name="suggestions"
                @slotchange=${this.onslotchangeHandler}
              ></slot>
            </div>
          </div>
          <div class="right-icon--container">
            <ex-icon-button
              ?circular=${this.type === "brand"}
              ?disabled=${this.disabled || this.invalid || this.isEmpty}
              icon="Send filled"
              label="Send filled"
              type="primary"
              flavor=${this.type === "brand" ? k.PERIWINKLE_GREEN : k.PERIWINKLE}
              size="M"
              @click=${() => {
      this.dispatchCustomEvent("onSend", { value: this.editor.getValue() }), this.clearOnSend && this.editor.clear(this.focused);
    }}
              tooltipText="Send"
              data-exo-locatorId-suffix=${A(this, "rich-input-send-button")}
            ></ex-icon-button>
          </div>
        </div>
        ${this.helpText && !this.errorMsg ? x`<div class="input-context-message input--help-text">
              <ex-icon icon="information" size=${w.S}></ex-icon>
              <span>&nbsp;${this.helpText}</span>
            </div>` : ""}
        ${this.errorMsg ? x`<div class="input-context-message input--error-message">
              <ex-icon icon="Error" size=${w.XS}></ex-icon>
              <span>&nbsp;${this.errorMsg}</span>
            </div>` : ""}
      </div>
    `;
  }
}
a.styles = L`
    ${M(`:host{--exo-component-rich-input-width: 400px;--exo-component-rich-input-padding-top: 16px;--exo-component-rich-input-padding-right: 16px;--exo-component-rich-input-padding-bottom: 16px;--exo-component-rich-input-padding-left: 16px;--exo-component-rich-input-action-width: 32px}:host .container{padding:var(--exo-spacing-3x-small);border-radius:calc(var(--exo-radius-large) - 2px);width:var(--exo-component-rich-input-width);min-height:var(--exo-spacing-3x-large);position:relative}:host .container.container--variant__branded,:host .container.container--variant__default{background:var(--exo-color-border)}:host .container:hover.container--variant__branded{background:linear-gradient(45deg,var(--exo-color-data-solid-periwinkle) 50%,var(--exo-color-data-solid-green) 100%)}:host .container:hover.container--variant__default{background:var(--exo-color-background-action-hover)}:host .container.container--state__focused.container--variant__branded{background:linear-gradient(45deg,var(--exo-color-data-solid-periwinkle) 50%,var(--exo-color-data-solid-green) 100%)}:host .container.container--state__focused.container--variant__default{background:var(--exo-color-background-selected)}:host .container.container--state__invalid.container--variant__branded,:host .container.container--state__invalid.container--variant__default{background:var(--exo-color-background-danger-strong)}:host .container.container--state__invalid:not(.container--state__focused) .inner-container{background:var(--exo-color-background-danger-weak)}:host .container.container--state__disabled.container--variant__branded,:host .container.container--state__disabled.container--variant__default{background:var(--exo-color-background-disabled);pointer-events:none}:host .container.container--state__disabled .inner-container .input--container .input--placeholder{color:var(--exo-color-background-disabled)}:host .container .inner-container{display:flex;background:var(--exo-color-background);width:calc(var(--exo-component-rich-input-width));min-height:var(--exo-spacing-3x-large);padding:var(--exo-component-rich-input-padding-top) var(--exo-component-rich-input-padding-right) var(--exo-component-rich-input-padding-bottom) var(--exo-component-rich-input-padding-left);border-radius:calc(var(--exo-radius-large) - 4px);box-sizing:border-box;align-items:center;justify-content:space-between;gap:var(--exo-spacing-standard)}:host .container .inner-container.inner-container--has-multiline{align-items:flex-end}:host .container .inner-container .left-icon--container,:host .container .inner-container .right-icon--container{width:var(--exo-component-rich-input-action-width);display:flex;justify-content:center}:host .container .inner-container .input--container{position:relative;width:calc(var(--exo-component-rich-input-width) - 4 * var(--exo-component-rich-input-action-width))}:host .container .inner-container .input--container .input--placeholder{color:var(--exo-color-font-secondary);position:absolute;top:50%;left:0;transform:translateY(-50%);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width:100%;text-align:left}:host .container .inner-container .input--container .suggestions{position:fixed;width:var(--exo-component-rich-input-width);border:var(--exo-spacing-4x-small) solid var(--exo-color-border);border-radius:var(--exo-radius-standard);box-shadow:var(--exo-box-shadow-moderate);background-color:var(--exo-color-background);padding:var(--exo-spacing-2x-small) var(--exo-spacing-none);outline:none;font:var(--exo-doc-body-small);z-index:999;max-height:188px;overflow:auto}:host .container .inner-container .input--container .suggestions.suggestions--hidden{display:none}:host .container .left-icon--container.hidden{display:none}:host .container .left-icon--container.hidden+.input--container{width:calc(var(--exo-component-rich-input-width) - 2 * var(--exo-component-rich-input-action-width))}:host .container .input-context-message{position:absolute;word-break:break-word;font-weight:var(--exo-font-weight-regular);display:flex;align-items:center;top:100%;height:18px;padding-top:var(--exo-spacing-3x-small)}:host .container .input-context-message.input--help-text{color:var(--exo-color-background-info-strong)}:host .container .input-context-message.input--error-message{color:var(--exo-color-background-danger-strong)}:host .container .input-context-message span{font-size:var(--exo-font-size-micro)}
`)}
  `, c([u()], a.prototype, "type", 2), c([u()], a.prototype, "value", 2), c([u()], a.prototype, "context", 2), c([u({ type: Boolean })], a.prototype, "invalid", 2), c([u({ type: Boolean })], a.prototype, "disabled", 2), c([u()], a.prototype, "placeholder", 2), c([u({ attribute: "help-text" })], a.prototype, "helpText", 2), c([u({ attribute: "error-message" })], a.prototype, "errorMsg", 2), c([u({ attribute: "clear-on-send", type: Boolean })], a.prototype, "clearOnSend", 2), c([u({ attribute: "allow-shift-enter", type: Boolean })], a.prototype, "allowShiftEnter", 2), c([g()], a.prototype, "editor", 2), c([g()], a.prototype, "isMultiline", 2), c([g()], a.prototype, "showSuggestions", 2), c([g()], a.prototype, "focused", 2), c([g()], a.prototype, "isEmpty", 2), c([g()], a.prototype, "suggestionPlacement", 2), c([g()], a.prototype, "hasSuggestion", 2), c([g()], a.prototype, "hasPrefix", 2), c([b(".suggestions")], a.prototype, "suggestions", 2), c([b(".container")], a.prototype, "container", 2), c([b('slot[name="suggestions"]')], a.prototype, "suggestionsSlot", 2), c([b('slot[name="left-action"]')], a.prototype, "leftActionSlot", 2);
const j = (h = "") => {
  B("ex-rich-input", a, h), D(h), V(h), O(h);
}, se = $({ tagName: "ex-rich-input", elementClass: a, react: T, events: { onMention: "onMention", onChange: "onChange", onFocus: "onFocus", onBlur: "onBlur", onSend: "onSend", onSuggestionSelect: "onSuggestionSelect" }, displayName: "ExRichInput", registerWebComponent: j });
export {
  se as ExRichInput,
  P as RichInputType,
  j as register
};
